










































import pdf from 'vue-pdf';
import { Job } from '@/models/jobs/job'; 
export default {
  name: 'viewAttachmentsPopUp',
components: {
  pdf,
},
data(){
  return {
      intermidateJobId:0,
      onShowReasonCodes:false,
  }
},
  props: {
    header: {
      default: '',
      type: String,
    },
    body: {
      default: '',
      type: String,
    },
    attachmentUrl: {
      default: '',
      type: String,
    },
    downLoadFileName: {
      default: '',
      type: String,
    },
    isPdf: {
      default: false,
      type: Boolean,
    },
    onCancel: {
    default: () => {},
    type: Function,
  },
  
  }
}

